var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { customElement, property, css, html, LitElement } from 'lit-element';
let TcButton = class TcButton extends LitElement {
    constructor() {
        super(...arguments);
        this.type = 'primary';
        this.disabled = false;
        this.width = 'auto';
        this.border = null;
        this.show = true;
        this.target = 'javascript:void(0)';
        this.img = null;
    }
    static get styles() {
        return css `
            .tc-button {
                position: relative;
                margin: 0;
                cursor: pointer;
                border: 0;
                box-sizing: border-box;
                vertical-align: middle;
                font-size: 1em;
                text-align: center;
                text-transform: none;
                text-decoration: none;
                transition: background-color 0.2s ease-out;
                -webkit-appearance: none;
                user-select: none;
                display: flex;
                width: fit-content;
                height: auto;
                line-height: 1.5em;
                align-items: center;
                padding: 7px 17px 8px;
            }

            .primary {
                background-color: var(--color-primary);
                color: var(--inverse-font-color);
                font-weight: 700;
            }
            @media (any-hover) {
                .primary:not(.disabled):hover {
                    background: var(--color-primary-dark);
                }
            }

            .secondary {
                background-color: var(--color-secondary-light);
                color: var(--secondary-font-color);
                font-weight: 500;
            }

            .primary-clear {
                color: var(--color-primary);
                border: 1px solid var(--color-primary);
                font-weight: 500;
            }

            .clear {
                color: var(--color-text);
                font-weight: 300;
            }

            .clear-underline {
                color: var(--color-text);
                text-decoration: underline;
                font-weight: 300;
            }

            @media (any-hover) {
                .secondary:not(.disabled):hover {
                    color: var(--inverse-font-color);
                    background: var(--color-secondary);
                }
            }

            .button-icon {
                margin-right: 0.5rem;
            }

            .important-accents {
                background-color: var(--color-important-accents);
                color: var(--inverse-font-color);
                font-weight: 700;
            }

            @media (any-hover) {
                .important-accents:not(.disabled):hover {
                    background: var(--color-important-accents-dark);
                }
            }

            .gray {
                background-color: var(--light-border-color);
                color: var(--inverse-font-color);
                font-weight: 500;
            }

            @media (any-hover) {
                .gray:not(.disabled):hover {
                    color: var(--inverse-font-color);
                    background: var(--light-border-color-semi-dark);
                }
            }

            .primary.disabled,
            .secondary.disabled,
            .gray.disabled,
            .important-accents.disabled {
                opacity: 0.5;
                cursor: initial;
            }
            .width-full {
                width: 100%;
                justify-content: center;
            }
            .border-radius {
                border-radius: 5px;
            }
            .d-none {
                display: none;
            }
        `;
    }
    render() {
        return html `
            <a
                href="${this.target}"
                class="tc-button ${this.show ? '' : 'd-none'} ${this.type} ${this.disabled ? 'disabled' : ''} 
            ${this.border ? `border-${this.border}` : ''}
            ${`width-${this.width}`}"
                ?disabled=${this.disabled}
            >
                ${this.img ? html `<img class="button-icon" src="${this.img}" />` : ''}
                <slot></slot>
            </a>
        `;
    }
};
__decorate([
    property({ type: String })
], TcButton.prototype, "type", void 0);
__decorate([
    property({ type: Boolean })
], TcButton.prototype, "disabled", void 0);
__decorate([
    property({ type: String })
], TcButton.prototype, "width", void 0);
__decorate([
    property({ type: String })
], TcButton.prototype, "border", void 0);
__decorate([
    property({ type: Boolean })
], TcButton.prototype, "show", void 0);
__decorate([
    property({ type: String })
], TcButton.prototype, "target", void 0);
__decorate([
    property({ type: String })
], TcButton.prototype, "img", void 0);
TcButton = __decorate([
    customElement('tc-button')
], TcButton);
export default TcButton;
